import { render, staticRenderFns } from "./AllBusinesses.vue?vue&type=template&id=97b57d04&"
import script from "./AllBusinesses.vue?vue&type=script&lang=js&"
export * from "./AllBusinesses.vue?vue&type=script&lang=js&"
import style0 from "./AllBusinesses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports